export const DESKTOP = 'DESKTOP';
export const MOBILE_AND_TABLET = 'MOBILE_AND_TABLET';
export const ANIMATION_DURATION_DEFAULT = 150;
